jQuery(document).ready(function ($) {

    var arrowPrev = '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m17.646 2.646a1.917 1.917 0 0 0 -2.707 0l-9 9a.5.5 0 0 0 0 .708l9 9a1.914 1.914 0 1 0 2.707-2.708l-6.646-6.646 6.646-6.646a1.916 1.916 0 0 0 0-2.708z"/></svg></button>',
        arrowNext = '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9.061 2.646a1.914 1.914 0 1 0 -2.707 2.708l6.646 6.646-6.646 6.646a1.914 1.914 0 0 0 2.707 2.708l9-9a.5.5 0 0 0 0-.708z"/></svg></button>';

    $('.js-slider-icons').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        accessibility: true,
        arrows: true,
        dots: true,
        fade: false,
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            {
                breakpoint: 951,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 551,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                }
            },
            {
                breakpoint: 451,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            }
        ]
    });

    $('.js-slider-list').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        accessibility: true,
        arrows: true,
        dots: true,
        fade: false,
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            {
                breakpoint: 951,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 551,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.js-slider-img').slick({
        variableWidth: true,
        slidesToScroll: 1,
        infinite: true,
        accessibility: true,
        arrows: true,
        dots: true,
        fade: false,
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            {
                breakpoint: 551,
                settings: {
                    dots: false
                }
            }
        ]
    });

    $('.js-slider-team').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        accessibility: true,
        arrows: true,
        dots: true,
        fade: false,
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            {
                breakpoint: 951,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 551,
                settings: {
                    slidesToShow: 2,
                    dots: false
                }
            },
            {
                breakpoint: 451,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                }
            }
        ]
    });

    $('.js-slider-partners').slick({
        variableWidth: true,
        slidesToScroll: 1,
        infinite: true,
        accessibility: true,
        autoplay: true,
        arrows: false,
        dots: false,
        fade: false,
        prevArrow: false,
        nextArrow: false,
    });

});
